module.exports = __webpack_public_path__ + "img/icon1.347a29cb.png";